import { Injectable } from '@angular/core';
import {Headers,Http} from "@angular/http";
import {environment} from "../../../environments/environment";
import { NgModel } from '@angular/forms';

@Injectable()
export class CardService {
      private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
      constructor(
        private http: Http
      ) { }

      //Fetch All Cardlist registered
      getCardList(offset,searchText,category_id) {
        let body = "offset="+offset+"&searchText="+searchText+"&category_id="+category_id+""
        const promise = new Promise((resolve, reject) => {
        const apiURL = environment.BASE_URL+'/cardslist';
            this.http.post(apiURL,body,{headers: this.headers})
            .toPromise()
            .then(
              res => { // Success
                resolve(res.json());
              }
            ).catch(
            err => {
              console.log(err.json());
              reject(err.json());
            }
          );
        });
        return promise;
      }

    //Fetch single card information
    getCardInfo(iCardId){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/cardinfo/'+iCardId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Fetch single card information
    getCategories(){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/categories';
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    //Delete Card
    deleteCardCall(iCardId){
        const promise = new Promise((resolve, reject) => {
            const apiURL = environment.BASE_URL+'/deletecard/'+iCardId;
            this.http.get(apiURL)
                .toPromise()
                .then(
                    res => { // Success
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
        });
        return promise;
    }

    createCard(cardValue){
        const promise = new Promise((resolve, reject) => {
            let body = "card_name="+cardValue.card_name+"&card_category="+cardValue.card_category+"&card_coin="+cardValue.card_coin+"&card_image_preview="+cardValue.card_image_preview+"&envelope_coin="+cardValue.envelope_coin+"&envelope_image_transparent="+cardValue.envelope_image_transparent+"&card_photo_count="+cardValue.card_photo_count+"&card_type="+cardValue.card_type+"&envelope_linear_image="+cardValue.envelope_linear_image+"&card_image_transparent="+cardValue.card_image_transparent+"&is_backdrop_set="+cardValue.is_backdrop_set+"&is_envelope_added="+cardValue.is_envelope_added+"&backdropname="+cardValue.backdropname;
            const apiURL = environment.BASE_URL+'/card/create';
            this.http.post(apiURL,body,{headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        //console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }

    updateCard(cardValue){
        const promise = new Promise((resolve, reject) => {
            let body = "card_name="+cardValue.card_name+"&card_id="+cardValue.card_id+"&card_category="+cardValue.card_category+"&card_coin="+cardValue.card_coin+"&card_image_preview="+cardValue.card_image_preview+"&envelope_coin="+cardValue.envelope_coin+"&envelope_image_transparent="+cardValue.envelope_image_transparent+"&card_photo_count="+cardValue.card_photo_count+"&card_type="+cardValue.card_type+"&envelope_linear_image="+cardValue.envelope_linear_image+"&card_image_transparent="+cardValue.card_image_transparent+"&is_backdrop_set="+cardValue.is_backdrop_set+"&is_envelope_added="+cardValue.is_envelope_added+"&backdropname="+cardValue.backdropname;
            const apiURL = environment.BASE_URL+'/card/update';
            this.http.post(apiURL,body,{headers: this.headers})
                .toPromise()
                .then(
                    res => { // Success
                        //console.log(res.json());
                        resolve(res.json());
                    }
                ).catch(
                err => {
                    console.log(err.json());
                    reject(err.json());
                }
            );
        });
        return promise;
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/cardsmaster/services/card.service.ts